import { useMutation } from 'react-query';
import useCreateMediaAssetMutation from './useCreateMediaAssetMutation.js';
import useUploadMediaAssetMutation from './useUploadMediaAssetMutation.js';

const useAddMediaAssetMutation = (options) => {
  const createMediaAssetMutation = useCreateMediaAssetMutation();
  const uploadMediaAssetMutation = useUploadMediaAssetMutation();

  return useMutation({
    mutationFn: async ({ videoId, file, sourceUrl, customData, platform, importData }) => {
      try {
        const { uploadTicket, data: mediaAsset } = await createMediaAssetMutation
          .mutateAsync({
            videoId,
            file,
            sourceUrl,
            customData,
            platform,
            importData,
          });

        const progress = (didStart, uploadedSize, totalSize) => {
          options?.onProgress?.(file, didStart, uploadedSize, totalSize, mediaAsset.id);
        };

        const { id: uploadId } = uploadTicket;
        const onSuccess = () => {
          options.onSuccess?.({ file, uploadId, mediaAssetId: mediaAsset.id });
        };
        // If the sourceUrl is provided, we don't need to upload the file since
        // it will be fetched from the sourceUrl in baas. We can also set progress
        // to 100% since the file is already uploaded.
        if (sourceUrl) {
          onSuccess();
          return;
        }

        await uploadMediaAssetMutation
          .mutateAsync({
            fileItem: file,
            progress,
            uploadTicket,
            isAborted: options.isAborted,
            onSuccess,
          }).catch(options.onError);
      } catch (error) {
        options.onError(error, file);
      }
    },
  });
};

export default useAddMediaAssetMutation;
